import { jsx as _jsx } from "react/jsx-runtime";
const StatusPill = ({ online }) => {
    if (online === undefined || online === null) {
        return _jsx("span", { className: "status-pill", children: "Unknown" });
    }
    const label = online ? 'Online' : 'Offline';
    const className = `status-pill status-pill--${online ? 'up' : 'down'}`;
    return _jsx("span", { className: className, children: label });
};
export default StatusPill;
